<template>
  <a-drawer
    width="45%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">

      <a-form-model-item prop="areac" >
        <span slot="label"><a-tooltip>{{$t('广告所在地')}}<template slot="title">精确到市</template></a-tooltip></span>
        <a-cascader :options="cityList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请选择')+$t('广告所在地')"
                    style="width: 100%" v-model="citySelected" allowClear @change="onCityChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item :label="$t('位置')" prop="position" >
        <a-select :placeholder="$t('请选择')+$t('位置')" v-model="form.position" allowClear>
          <a-select-option
            v-for="(item, index) in customDict.BannerPositionEnum"
            :value="item.type"
            :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('广告名称')" prop="name" >
        <a-input v-model="form.name" :maxLength="16" :placeholder="$t('请输入')+$t('广告名称')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['name']"
            input-type="input"
            table-name="advert_banner"
            table-field="name"
            :field-value="form.name"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('开始时间')" prop="startTime">
        <a-date-picker
          v-model="form.startTime"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          show-time
          :placeholder="$t('开始时间')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('结束时间')" prop="endTime">
        <a-date-picker
          v-model="form.endTime"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          show-time
          :placeholder="$t('结束时间')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('排序')" prop="sort" >
        <a-input-number v-model="form.sort" :maxLength="6" style="width: 100%" :min="0" :max="9999" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('是否显示')" prop="isShow" >
        <a-radio-group v-model="form.isShow">
          <a-radio v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <!--      <a-form-model-item :label="$t('展示时长')" prop="showTimes" >
              <a-input-number
                v-model="form.showTimes"
                suffix="/s"
                :maxLength="6"
                style="width: 100%"
                @change="limitShowTimes"
                :placeholder="$t('请输入')+$t('展示时长')" />
            </a-form-model-item>-->
      <a-form-model-item :label="$t('封面图')" prop="coverImg" >
        <a-upload
          name="coverImg"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.coverImg"
            :src="form.coverImg"
            alt="picture"
            style="height: 102px; width: 102px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('上传') }}</div>
          </div>
        </a-upload>
        <span>推荐尺寸 {{ getBannerSize() }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('详情图')" prop="detailImg" >
        <a-upload
          name="detailImg"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverDetailImgUpload">
          <img
            v-if="form.detailImg"
            :src="form.detailImg"
            alt="detailImg"
            style="height: 102px; width: 102px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('上传') }}</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('跳转类型')" prop="type" >
        <a-select :placeholder="$t('请选择')+$t('跳转类型')" v-model="form.type" @change="typeChange" allowClear>
          <a-select-option
            v-for="(item, index) in customDict.BannerTypeEnum"
            :value="item.type"
            :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('选择商品')" prop="businessId"  v-if="form.type===2" >
        <a-button type="dashed" @click="openProdSelect" danger>
          <span style="color: dodgerblue"> {{getGoodsName()}}</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item :label="$t('内容详情')" prop="businessId" v-if="form.type===5" >
        <a-input v-model="form.businessId" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('选择文章')" prop="businessId" v-if="form.type===3">
        <a-button type="dashed" @click="openNewsSelect" danger>
          <span style="color: dodgerblue"> {{getNewsName()}}</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item :label="$t('小程序原始ID')" prop="businessId" v-if="form.type===4" >
        <a-input v-model="form.businessId" :placeholder="$t('请输入')" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('小程序APPID')" prop="appId" v-if="form.type===4" >
        <a-input v-model="form.appId" :placeholder="$t('请输入')" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('小程序跳转路径')" prop="content" v-if="form.type===4">
        <a-input v-model="form.content" :placeholder="$t('请输入小程序跳转路径')" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('店铺ID')" prop="businessId" v-if="form.type===9">
        <a-input v-model="form.businessId" :placeholder="$t('请输入店铺ID')" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('头条文章ID')" prop="businessId" v-if="form.type===10">
        <a-input v-model="form.businessId" :placeholder="$t('请输入头条文章ID')" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('功能页')" prop="businessId" v-if="form.type===11">
        <a-select v-model="form.businessId" :placeholder="$t('请选择')+$t('功能页')" allowClear>
          <a-select-option
            v-for="(item, index) in nativePageOptions"
            :value="item.value"
            :key="index">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 数据展示 -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>
    <goods-radio-select ref="goodsRadioSelect" @goodsSelect="indexGoodsModalSelect"/>
    <news-radio-select ref="newsRadioSelect" @newsSelect="indexNewsModalSelect"/>

  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner, bannerPosition} from '@/api/advert/banner'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { uploadObject, uploadOss } from '@/api/tool/oss'
import Editor from '@/components/Editor'
import { tableMixin } from '@/store/table-mixin'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import GoodsRadioSelect from '@/views/goods/goods/select/GoodsRadioSelect.vue'
import NewsRadioSelect from '@/views/help/problem/modules/NewsRadioSelect.vue'

export default {
  name: 'CreateForm',
  props: {
    cityList: {
      require: true,
      type: Array
    }
  },
  components: {
    LocaleFieldButton,
    GoodsRadioSelect,
    NewsRadioSelect,
    CustomDictTag,
    Editor
  },
  mixins: [tableMixin],
  data () {
    return {
      disable: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      goodsLoading: false,
      atvLoading: false,

      cateOptions: [],
      bannerPositionOptions: [],

      activityColumns: [
        {
          title: this.$t('活动记录.活动编号'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('活动记录.活动类型'),
          dataIndex: 'activityType',
          scopedSlots: { customRender: 'activityType' },
          align: 'center'
        },
        {
          title: this.$t('活动记录.活动名称'),
          dataIndex: 'activityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('活动记录.开始时间'),
          dataIndex: 'startTime',
          scopedSlots: { customRender: 'startTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('活动记录.结束时间'),
          dataIndex: 'endTime',
          scopedSlots: { customRender: 'endTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('活动记录.活动封面图'),
          dataIndex: 'coverPic',
          scopedSlots: { customRender: 'coverPic' },
          align: 'center'
        },
        {
          title: this.$t('活动记录.状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('活动记录.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ],
      goodsColumns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          fixed: 'left'
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          fixed: 'left'
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
      ],
      newsColumns: [
        {
          title: 'id',
          dataIndex: 'id',
        },
        {
          title: this.$t('标题'),
          dataIndex: 'title',
        },
        {
          title: this.$t('简述'),
          dataIndex: 'sketch',
        },
      ],
      citySelected: [],
      // 功能页跳转（NATIVE）可选目标，businessId 存储路由 key，需与 App/H5 端约定一致
      nativePageOptions: [
        { value: 'mall', label: '乐器商城首页' },
        { value: 'secondHand', label: '二手交易' },
        { value: 'parts', label: '乐器配件' },
        { value: 'sheet', label: '乐谱' },
        { value: 'edu', label: '音乐教育' },
        { value: 'community', label: '同城社区' },
        { value: 'recycle', label: '二手回收' },
        { value: 'coupon', label: '领券中心' }
      ],

      // 表单参数
      form: {
        id: null,
        activityList: [],
        areac: undefined,
        areap: undefined,
        position: 1,
        type: undefined,
        name: null,
        businessId: null,
        appId: null,
        businessName: null,
        sort: 0,
        content: null,
        isShow: true,
        showTimes: null,
        coverImg: null,
        detailImg: null,
        startTime: null,
        endTime: null,
        userApplyId: null,
        remark: null,
        localeFieldMap: {},


      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        position: [
          { required: true, message: this.$t('位置') + this.$t('不能为空'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('广告名称') + this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('不能为空'), trigger: 'blur' }
        ],
        businessId: [
          { required: true, message: this.$t('不能为空'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('不能为空'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('开始时间') + this.$t('不能为空'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('结束时间') + this.$t('不能为空'), trigger: 'change' }
        ],
        sort: [
          { required: true, message: this.$t('排序') + this.$t('不能为空'), trigger: 'blur' }
        ],
        isShow: [
          { required: true, message: this.$t('是否隐藏') + this.$t('不能为空'), trigger: 'blur' }
        ],
        coverImg: [
          { required: true, message: this.$t('封面图') + this.$t('不能为空'), trigger: 'blur' }
        ],
        cateId: [

        ]
        /* showTimes: [
          { required: true, message: this.$t('展示时长') + this.$t('不能为空'), trigger: 'blur' }
        ] */
      }
    }
  },
  filters: {
  },
  created () {
    this.getBannerPosition();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    limitSort(sort) {
      let val = sort
      if (val == null || val === undefined || val === '') {
        val = 0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },
    onCityChange() {
      this.form.areac=this.citySelected[1]
    },
    typeChange() {
      console.log('type改变为', this.form.type)
      if (this.form.type === 2) {
        this.form.businessId = undefined
      }
      if (this.form.type === 4) {
        this.form.businessId = undefined
      }
    },

    indexGoodsModalSelect(records) {
      this.form.businessId = records[0].id
      this.form.businessName = records[0].goodsName
    },
    openProdSelect() {
      console.log('打开商品选择框,单选模式')
      this.$refs.goodsRadioSelect.openGoods(this.form.businessId,null, null, [20,21]);
    },
    getGoodsName() {
      if (this.form.businessName) {
        return this.form.businessName
      } else {
        return this.$t('请选择')+this.$t('商品')
      }
    },

    getNewsName() {
      if (this.form.businessName) {
        return this.form.businessName
      } else {
        return this.$t('请选择')+this.$t('文章')
      }
    },



    indexNewsModalSelect(records) {
      this.form.businessId = records[0].id
      this.newsList = records
      console.log('文章选择了',this.newsList)
    },
    openNewsSelect() {
      console.log('打开文章选择框,单选模式')
      this.$refs.newsRadioSelect.openNews(this.form.businessId);
    },
    // oss 上传开始
    async handlePreview(file) {
      const suffix = file.name.substring(file.name.lastIndexOf('.'))
      if (suffix === '.mp4') {
        this.handleVideoPreview(file)
      } else {
        this.handleImagePreview(file)
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'coverImg', res)
          _this.$message.success(this.$t('上传成功'))
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'detailImg', res)
          _this.$message.success(this.$t('上传成功'))
        })
      })
    },
    // oss 上传结束

    // 表单重置
    reset () {
      this.disable = false
      this.formType = 1
      this.form = {
        id: null,
        position: 1,
        areac: undefined,
        areap: undefined,
        type: undefined,
        name: null,
        activityList: [],
        businessId: '',
        appId: null,
        businessName: null,
        sort: 0,
        content: null,
        isShow: true,
        showTimes: null,
        coverImg: null,
        detailImg: null,
        startTime: null,
        endTime: null,
        userApplyId: null,
        remark: null,
        localeFieldMap: {},
      }
      this.citySelected= []
    },
    getBannerSize() {
      if (this.bannerPositionOptions.length > 0) {
        if (this.form.position) {
          return this.bannerPositionOptions.find(e => e.type === this.form.position).size
        } else {
          return this.bannerPositionOptions[0].size
        }
      }
    },
    getBannerPosition() {
      bannerPosition().then(response => {
        this.bannerPositionOptions = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      this.disable = true
      const id = row ? row.id : ids
      getBanner({ 'id': id }).then(response => {
        this.form = response.data
        if (this.form.areac && this.form.areap) {
          this.citySelected.push(this.form.areap)
          this.citySelected.push(this.form.areac)
        }
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateBanner(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addBanner(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
